import * as ActionTypes from '../actions'
import { SUCCESS } from '../actions'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { getCurrentGoods } from '../components/common/utils'
import commonReducer from './common'
import uiReducer from './ui'
import ossReducer from './oss'
import owsiReducer from './owsi'
import efriReducer from './efri'
import mermaidReducer from './mermaid'
import freediveriReducer from './fdi'
import afdiReducer from './afdi'
import mfdiReducer from './mfdi'

export function updateEcardsActiveStatus(state, data, binding) {
  let certifications = state.certifications
  let credentials = state.credentials
  if (binding) {
    data.map((item) => {
      const activeCertifications = certifications.find((cert) => cert.affiliateCertificationId === item.ecardId)
      if (activeCertifications) {
        if (item.ecardImageId) {
          // ecardImages 可为 null（Ecard.java 无默认初始化）：缺空判会抛 TypeError，中断 CardStatusBtn 的
          // onSuccess（弹了「成功」但 Redux 没更新）。对齐下方 binding=false 分支的写法。
          if (activeCertifications.ecardImages)
            activeCertifications.ecardImages.forEach((ecard) => {
              if (ecard.ecardImageId === item.ecardImageId) {
                if (activeCertifications.ecardImages)
                  activeCertifications.ecardImages.forEach((ecard2) => (ecard2.active = false))
                if (activeCertifications.customizedImages)
                  activeCertifications.customizedImages.forEach((ecard2) => (ecard2.active = false))
                ecard.active = true
              }
            })
        }
        if (item.bindingId) {
          activeCertifications.customizedImages.forEach((ecard) => {
            if (ecard.id === item.bindingId) {
              if (activeCertifications.ecardImages)
                activeCertifications.ecardImages.forEach((ecard2) => (ecard2.active = false))
              if (activeCertifications.customizedImages)
                activeCertifications.customizedImages.forEach((ecard2) => (ecard2.active = false))
              ecard.active = true
            }
          })
        }
      }
    })
    data.map((item) => {
      const activeCredentials = credentials.find((cert) => cert.affiliateCredentialId === item.ecardId)
      if (activeCredentials) {
        if (item.ecardImageId) {
          // 同 certifications 分支：ecardImages 可为 null，缺空判会抛 TypeError
          if (activeCredentials.ecardImages)
            activeCredentials.ecardImages.forEach((ecard) => {
              if (ecard.ecardImageId === item.ecardImageId) {
                if (activeCredentials.ecardImages)
                  activeCredentials.ecardImages.forEach((ecard2) => (ecard2.active = false))
                if (activeCredentials.customizedImages)
                  activeCredentials.customizedImages.forEach((ecard2) => (ecard2.active = false))
                ecard.active = true
              }
            })
        }
        if (item.bindingId) {
          activeCredentials.customizedImages.forEach((ecard) => {
            if (ecard.id === item.bindingId) {
              if (activeCredentials.ecardImages)
                activeCredentials.ecardImages.forEach((ecard2) => (ecard2.active = false))
              if (activeCredentials.customizedImages)
                activeCredentials.customizedImages.forEach((ecard2) => (ecard2.active = false))
              ecard.active = true
            }
          })
        }
      }
    })
  } else {
    data.map((item) => {
      const activeCertifications = certifications.find((cert) => cert.affiliateCertificationId === item)
      if (activeCertifications) {
        if (activeCertifications.ecardImages) {
          activeCertifications.ecardImages.forEach((ecard) => {
            ecard.active = false
          })
        }
        if (activeCertifications.customizedImages) {
          activeCertifications.customizedImages.forEach((ecard) => {
            ecard.active = false
          })
        }
      }
    })
    data.map((item) => {
      const activeCredentials = credentials.find((cert) => cert.affiliateCredentialId === item)
      if (activeCredentials) {
        if (activeCredentials.ecardImages) {
          activeCredentials.ecardImages.forEach((ecard) => {
            ecard.active = false
          })
        }
        if (activeCredentials.customizedImages) {
          activeCredentials.customizedImages.forEach((ecard) => {
            ecard.active = false
          })
        }
      }
    })
  }
  return { ...state, certifications, credentials }
}

function updateBindingImage(state, data, type) {
  const updateData = data[0]
  const { ecardId } = updateData
  const certifications = state.certifications.map((c) => {
    if (c.affiliateCertificationId === ecardId) {
      const ecardImages = c.ecardImages
      ecardImages && ecardImages.map((item) => (item.active = false))
      const newEcardImages = ecardImages ? [...ecardImages, updateData] : [updateData]
      return { ...c, ecardImages: newEcardImages }
    }
    return c
  })
  const credentials = state.credentials.map((c) => {
    if (c.affiliateCredentialId === ecardId) {
      const ecardImages = c.ecardImages
      ecardImages && ecardImages.map((item) => (item.active = false))
      const newEcardImages = ecardImages ? [...ecardImages, updateData] : [updateData]
      return { ...c, ecardImages: newEcardImages }
    }
    return c
  })
  return { ...state, certifications, credentials }
}

// Updates an entity cache in response to any action with response.entities.
function data(state = {}, { type, data }) {
  switch (type) {
    case ActionTypes.SUBMIT_ECARD_IMG_BINDING[SUCCESS]:
      return updateBindingImage(state, data, 'newYear')
    case ActionTypes.ECARDS[SUCCESS]:
    case ActionTypes.REFRESH_ECARDS:
      const { wechatUser, ...ecardsResult } = data
      return { ...state, ...ecardsResult }
    case ActionTypes.REDEEMED_FREE_CARDS[SUCCESS]:
      // 已兑免费首卡证书列表（数组），失败降级为 []（selector 兜底），保持展示旧行为
      return { ...state, redeemedFreeCards: data }
    case ActionTypes.CARDREQUESTOPTIONS[SUCCESS]:
      const cardRequestOptions = { ...state.cardRequestOptions, ...data }
      return { ...state, cardRequestOptions }
    case ActionTypes.SHAREECARDS[SUCCESS]:
      return { ...state, ...data }
    case ActionTypes.WECHATUSER[SUCCESS]:
      return { ...state, wechatUser: data }
    case ActionTypes.VERIFY_MOBILE_CODE:
      const { code, ...mobile } = data
      return { ...state, profile: { profile: { ...state.profile.profile, ...mobile }, wechat: state.profile.wechat } }
    case ActionTypes.PROFILE[SUCCESS]:
      return { ...state, profile: data }
    case ActionTypes.SAVE_PROFILE:
      const { ...saveProfile } = data
      return {
        ...state,
        profile: { profile: { ...state.profile.profile, ...saveProfile }, wechat: state.profile.wechat },
      }
    case ActionTypes.FORGOT_PASSWORD:
      return { ...state, forgotPassword: data.email }
    case ActionTypes.POST_PASSWORD:
      const { password } = data
      return { ...state, profile: { profile: { ...state.profile.profile, password }, wechat: state.profile.wechat } }
    case ActionTypes.POST_PROFILE:
      const { firstName, lastName, gender, birthDate } = data
      return {
        ...state,
        profile: {
          profile: { ...state.profile.profile, firstName, lastName, gender, birthDate },
          wechat: state.profile.wechat,
        },
      }
    case ActionTypes.SHOPPINGCART[SUCCESS]:
      return { ...state, shoppingCart: data }
    case ActionTypes.DELECT_CART_ITEM:
      const shopCartItems = state.shoppingCart.data
      const otherShopItems = shopCartItems.filter((item) => item.skuId !== data.skuId || item.ecardId !== data.ecardId)
      const newShoppingCart = { ...state.shoppingCart, data: otherShopItems }
      return { ...state, shoppingCart: newShoppingCart }
    case ActionTypes.ADD_TO_CART:
      const certName = state.cardRequest.certificationName || state.cardRequest.credentialName
      const shoppingCartAfterAdd = getCurrentGoods(state.cardRequestOptions, data, certName)
      const { shoppingCart } = state
      return { ...state, shoppingCart: { ...shoppingCart, data: [...shoppingCart.data, shoppingCartAfterAdd] } }
    case ActionTypes.REPLACE_CARD:
      const certificationName = state.cardRequest.certificationName || state.cardRequest.credentialName
      const shoppingCartItems = state.shoppingCart.data
      const otherShopCartItems = shoppingCartItems.filter((item) => item.ecardId !== data.ecardId)
      const shoppingCartAfterReplace = getCurrentGoods(state.cardRequestOptions, data, certificationName)
      return {
        ...state,
        shoppingCart: { ...state.shoppingCart, data: [...otherShopCartItems, shoppingCartAfterReplace] },
      }
    case ActionTypes.SAVE_PROFILE[SUCCESS]:
      const { wechat } = state.profile
      const newProfile = { profile: data, wechat }
      return { ...state, profile: newProfile }
    case ActionTypes.CLEAR_CARDREQUEST_INFO:
      const { cardRequest, ...rest } = state
      return rest
    case ActionTypes.ADD_ECARD_DATA:
      const { certifications = [], credentials = [] } = state
      const certsList = certifications.concat(credentials)
      const ecard = certsList.find((e) => e.uniqueId === decodeURIComponent(data))
      return { ...state, cardRequest: ecard }
    case ActionTypes.LOGIN_SUCCESS:
      return {}
    case ActionTypes.CHNAGE_ECARDS_ACTIVE_TRUE:
      return updateEcardsActiveStatus(state, data, true)
    case ActionTypes.CHNAGE_ECARDS_ACTIVE_FALSE:
      return updateEcardsActiveStatus(state, data, false)
    default:
      return state
  }
}

function entityRequestStatus(state = {}, { type, data, error }) {
  if (/_REQUEST$/.test(type)) {
    const entity = type.replace(/_REQUEST$/, '')
    return { ...state, [entity]: ActionTypes.ENTITY_REQUESTING }
  }
  if (/_FAILURE$/.test(type)) {
    const entity = type.replace(/_FAILURE$/, '')
    return { ...state, [entity]: ActionTypes.ENTITY_FAILURE }
  }

  if (/_SUCCESS$/.test(type)) {
    const entity = type.replace(/_SUCCESS$/, '')
    const { [entity]: value, ...rest } = state
    return rest
  }
  return state
}

export default (history) =>
  combineReducers({
    data,
    common: commonReducer,
    ui: uiReducer,
    oss: ossReducer,
    owsi: owsiReducer,
    efri: efriReducer,
    mermaid: mermaidReducer,
    FDI: freediveriReducer,
    AFDI: afdiReducer,
    MFDI: mfdiReducer,
    router: connectRouter(history),
    entityRequestStatus,
  })
